module.exports = __webpack_public_path__ + "static/media/13.2e806b8a.jpg";